import script from "./Tooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tooltip.vue?vue&type=script&setup=true&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=31a417d8&lang=scss"

const __exports__ = script;

export default __exports__